<template>
  <div>
    <fixed-header title="NCM Code Management" hideNewOfferBtn />
    <div class="animated fadeIn BillPayments--BillPayments-list">
      <div class="card">
        <div class="card-body d-flex flex-column">
          Select the value that you want to manage or enter a new value
          <b-form @submit="onSubmit">
            <b-row class="mb-2 mt-2">
              <b-col cols="4">
                <b-form-group label="Code" class="required" label-cols-sm="3" label-cols-lg="3">
                  <b-form-input v-model="formData.code" :class="{ 'is-invalid': $v.formData.code.$error }"/>
                  <b-form-invalid-feedback>Code is required</b-form-invalid-feedback>
                </b-form-group>
              </b-col>
              <b-col cols="2">
                <b-button :disabled="isSaving"
                  v-if="((formData.id && checkClaim(CAN_EDIT_LOOKUP)) || (!formData.id && checkClaim(CAN_ADD_LOOKUP)))"
                  type="submit" variant="primary" class="btn-sm mr-2"><i v-show="isSaving" class="fa fa-spinner fa-pulse fa-fw mr-1"></i>Save
                </b-button>
                <b-button type="button" variant="secondary" class="btn-sm" @click="resetForm">Cancel</b-button>
              </b-col>
            </b-row>
            <b-row class="mb-2">
              <b-col cols="4">
                <b-form-group label="Description" label-cols-sm="3" label-cols-lg="3">
                  <b-form-textarea max-rows="6" rows="4" v-model="formData.description"/>
                </b-form-group>
              </b-col>
            </b-row>
          </b-form>
          <grid-component
            :gridId="gridId"
            :itemData="itemData"
            :fields="fields"
            :handleRowClick="handleRowClick"
            :onDelete="onDelete"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { required } from 'vuelidate/lib/validators';
  import FixedHeader from '@/shared/components/FixedHeader/indexNew';
  import GridSettings from '@/shared/components/GridSettings';
  import GridComponent from '@/shared/components/GridComponent';
  import fields from './fields';
  import service from './service';

  export default {
    components: {
      GridSettings,
      FixedHeader,
      GridComponent,
    },
    data() {
      return {
        fields,
        gridId: 'ncmcodes-table',
        tableList: [],
        lookupTableValues: [],
        formData: {
          id: 0,
          code: '',
          description: '',
          active: true,
        },
        isSaving:false,
      };
    },
    metaInfo: () => ({
      title: 'NCM Code Management',
    }),
    validations: {
      formData: {
        code: { required },
      },
    },
    computed: {
      itemData() {
        return this.lookupTableValues.map((lookup) => ({ ...lookup, selected: lookup.id === this.formData.id }));
      },
    },
    methods: {
      async onSubmit(evt) {
        evt.preventDefault();
        this.$v.formData.$touch();
        if (this.$v.formData.$invalid) {
          return;
        } else {
          try {
            this.isSaving = true;
            let id = await service.manageNcmCodes(this.formData);
            this.isSaving = false;
            this.resetForm();
            if (id) {
              this.getLookupTableValues();
            }
          }catch (e) {
            this.isSaving = false;
          }
        }
      },
      resetForm() {
        this.formData = {
          id: 0,
          code: '',
          description: '',
          active: true,
        };
        this.$v.$reset();
        this.$v.formData.$reset();
      },
      async getLookupTableValues() {
        this.lookupTableValues = await service.getNcmCodes();
      },
      handleRowClick(row) {
        this.formData = row.dataItem;
        console.log(this.formData,row.dataItem);
      },
      async onDelete(row) {
        const deleteConfirmed = await this.openConfirmBox({});
        if (deleteConfirmed) {
          await service.deleteNcmCodes(row.id);
          //Get the data
          this.getLookupTableValues();
        }
      },
    },
    mounted() {
      this.getLookupTableValues();
    },
  };
</script>

